import config from '../config'
import fetcher from './fetcher'

export * as videosApi from './videos'
export * as usersApi from './users'
export * as gptApi from './gpt'
export * as cvRoasterApi from './cv-roaster'

export const simpleFetch = async <T>(url: string): Promise<Array<T>> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api${url}`, { method: 'GET' })
		return res.data
  } catch (error) {
    console.error(`Error fetching ${url}: ${error}`)
    throw new Error(`Error fetching ${url}`)
  }
}
